import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/** Core actions for configurable Space dimension filter features. */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Stores selected record IDs for one DMS entity in memory. */
    setSelection: store.actions.request({
      input: store.actions.Data.asIs<{
        readonly entityId: ents.core.dms.models.Entity.Id
        readonly recordIds: readonly ents.core.dms.data.Record.Id[]
      }>(),
      output: store.actions.Data.NONE,
    }),
    /** Clears the in-memory selection for every entity in the dimension. */
    resetSelections: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
    }),
    /** Loads all options, or reloads options matching the supplied criteria. */
    loadOptions: store.actions.standalone({
      data: store.actions.Data.asIs<
        | {
            readonly criteria: ents.extra.space.Filter.Option.Criteria
          }
        | undefined
      >(),
    }),
    /** Loads selectable options for one DMS entity. */
    load: store.actions.request({
      input: store.actions.Data.asIs<{
        readonly context: ents.core.admin.Context.ForScenario
        readonly criteria: ents.extra.space.Filter.Option.Criteria
      }>(),
      output:
        store.actions.Data.asIs<readonly ents.extra.space.Filter.Option[]>(),
      reducers: {
        request: ({ state, data: { criteria } }): State =>
          State.setOptionsLoading(state, criteria.entityId),
        success: ({ state, data: { request, response } }): State =>
          State.setOptionsLoaded(state, request.criteria.entityId, response),
        error: ({ state, data: { error, request } }): State =>
          State.setOptionsError(state, request.criteria.entityId, error),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
